import React from "react"
import { Helmet } from "react-helmet"

function HeaderMeta() {
  let meta = []
  meta = process.env.GATSBY_GOOGLE_SITE_VERIFICATION_KEY ? [
    {
      name: `google-site-verification`,
      content: `${process.env.GATSBY_GOOGLE_SITE_VERIFICATION_KEY}`
    }
  ].concat(meta) : meta

  return (
    <Helmet
      meta={meta}
    />
  )
}

export default HeaderMeta
